import { Command } from 'commands/Commands';

export class ChangeArticleMetaDescription extends Command {
  type: string = 'BlogArticle.ChangeMetaDescription';
  constructor(id: string, newValue: string) {
    super(newValue, id);
  }
  priority: number = 100;
}
